import React, { useState, useEffect } from "react";
import { API_ENDPOINTS } from "@/src/config/api.js";

const RecentThreads = () => {
    const [feedPosts, setFeedPosts] = useState([]);

    const decodeHtmlEntities = (value) => {
        if (!value) return "";
        const parser = new DOMParser();
        const doc = parser.parseFromString(value, "text/html");
        return doc.documentElement.textContent || "";
    };

    useEffect(() => {
        fetch(API_ENDPOINTS.activity.recent(20))
            .then(response => response.json())
            .then(data => {
                // Filter out posts with type 'general' and 'totd-promo' if body.homeFeature is false
                const filteredPosts = data.activities.filter(post =>
                    post.type.toLowerCase() !== 'general' ||
                    (post.type.toLowerCase() === 'totd-promo' &&
                        post.body?.homeFeature === false)
                );
                setFeedPosts(filteredPosts);
            })
            .catch(error => console.error("Error fetching feed posts:", error));
    }, []);

    return (
        <div className="bg-neutral-900 rounded-lg p-4">
            <h2 className="font-bold text-lg mb-4">RECENT THREADS</h2>
            <div className="max-h-[1180px] overflow-y-auto pr-2 relative scroll-smooth" style={{
                scrollbarWidth: 'thin',
                scrollbarColor: '#4B5563 #1F2937'
            }}>
                {feedPosts.map((post) => (
                    <div key={post.id} className="bg-neutral-900 rounded-lg overflow-hidden mb36">
                        <div className="p-4">
                            <div className="flex space-x-4 pb-4" style={{ borderBottom: '1px dotted #3b3b3b' }}>
                                {post.img_url && (
                                    <a href={post.link_url} className="flex-shrink-0">
                                        <img
                                            src={post.img_url}
                                            alt={decodeHtmlEntities(post.title)}
                                            className={`w-[120px] h-[70px] object-cover rounded-md ${post.img_url.includes('icon_totd.gif') ? 'bg-white' : ''}`}
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = "//www.dreamchimney.com/tracks/track_images/default.jpg";
                                            }}
                                        />
                                    </a>
                                )}
                                <div className="flex-1">
                                    <a href={post.link_url} className="hover:text-gray-300">
                                        <h3 className="text-base mb-3">{decodeHtmlEntities(post.title)}</h3>
                                    </a>
                                    <div>
                                        {post.body?.full_name && <p className="font-medium mb-2">by {post.body.full_name}</p>}
                                        <p className="text-xs text-gray-400">{post.date.date}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <div className="h-6 -mt-6 bg-gradient-to-t from-neutral-900 to-transparent pointer-events-none"></div>
        </div >
    );
};

export default RecentThreads; 